import graph from './graphMany'

export const fetchGraphMany =
  (req, pairs, ctx = {}) =>
  async _ => {
    const res = await graph(req, pairs, ctx)
    return res
  }
